// allow for external hyperlinks outside of the app. External links should open a new tab

export const HyperLinkRenderer = (
  root: string,
  idOverride?: number,
  nameOverride?: string,
  external?: boolean,
) => {
  return function CreateHyperLinkRenderer(props: any) {
    let id;
    if (root.toLowerCase() === "deals") {
      if (
        !props.data?.dealId &&
        props.data?.deal?.dealId === null &&
        props.data?.deal?.id === null
      )
        return null;
      id =
        props.data?.dealId ?? props.data?.deal?.dealId ?? props.data?.deal?.id;
    } else if (root.toLowerCase() === "assets") {
      id = props.data?.id;
    } else {
      id = idOverride ? idOverride : props.data?.id;
    }
    const name = nameOverride ? nameOverride : props.value;
    const link = external ? `${root}${id}` : `/${root}/${id}`;
    return (
      <a
        href={link}
        target={external ? "_blank" : "_self"}
        rel={external ? "noopener noreferrer" : undefined}
        style={{ color: "#1B7A63", textDecoration: "underline" }}
      >
        {name}
      </a>
    );
  };
};
